import ButtonGsfurn from "components/General/ButtonGsfurn/ButtonGsfurn";
import { CodeInputField } from "@notanumber/nan-component-library";

const ValidateForm = ({ onSubmit, infoText }) => {
  function handleOnSubmit(e) {
    e.stopPropagation();
    e.preventDefault();

    const form = e.target;
    const data = new FormData(form);
    const fields = Object.fromEntries(data.entries());
    if (onSubmit) {
      onSubmit(fields);
    }
  }

  return (
    <form
      className="flex flex-col gap-4"
      onSubmit={handleOnSubmit}
    >
      {infoText && (
        <div>
          <p className="mb-0 text-dark-text">
            {infoText}
          </p>
        </div>
      )}
      <div className="flex gap-5 mb-1">
        <CodeInputField
          classNames={{
            container: "flex gap-3 justify-between",
          }}
          theme={{
            base: "flex h-10 w-full",
            field: {
              input: {
                base: "block overflow-hidden border-none rounded-5 disabled:cursor-not-allowed disabled:opacity-50 text-center !h-12 w-full focus:border-yellow_grw focus:ring-0",
              }
            }
          }}
        />
        <ButtonGsfurn
          color="yellow_grw"
          size="xl"
          type="submit"
        >
          Inloggen
        </ButtonGsfurn>
      </div>
    </form>
  )
}

export default ValidateForm;